import React, { Fragment } from 'react'

import { withStyles, Box } from '@material-ui/core'

const LoadingIndicator = ({ show, progress }) => {
  let loader = null
  if (show) {
    loader = (
      <ProgressContainer>
        <ProgressLine style={{ width: `${progress}%` }} />
      </ProgressContainer>
    )
  }

  return (
    <Fragment>
      <BackDropBox>{loader}</BackDropBox>
    </Fragment>
  )
}

const BackDropBox = withStyles(theme => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    opacity: 0.7,
    position: 'relative'
  }
}))(Box)

const ProgressContainer = withStyles(theme => ({
  root: {
    transition: 'width .5s ease-in',
    height: 8
  }
}))(Box)

const ProgressLine = withStyles(theme => ({
  root: {
    height: '100%',
    background: `linear-gradient(
    90deg,
    #3fe02a,
    #4ee23b 17%,
    #5ee54c 34%,
    #6de75d 51%,
    #b7e5c1 68%,
    #c3e9cb 85%,
    #cfedd5
  )`,
    backgroundSize: '300% 100%',
    animation: '$infinite-loading 2s linear infinite'
  },
  '@keyframes infinite-loading': {
    '0%': { backgroundPosition: '100%' },
    '25%': { backgroundPosition: '75%' },
    '75%': { backgroundPosition: '25%' },
    '100%': { backgroundPosition: '0' }
  }
}))(Box)

export default LoadingIndicator
